/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IMlCarouselData } from './ml-carousel.data';
import { ICarouselItemData, IMlCarouselProps } from './ml-carousel.props.autogenerated';

export interface IMlCarouselViewProps extends IMlCarouselProps<IMlCarouselData> {
    slides: ICarouselItemData[];
    autoPlay: boolean;
    autoPlayInterval: number;
}

/**
 *
 * MlCarousel component
 * @extends {React.PureComponent<IMlCarouselProps<IMlCarouselData>>}
 */
class MlCarousel extends React.PureComponent<IMlCarouselProps<IMlCarouselData>> {
    public render(): JSX.Element | null {
        const { config } = this.props;
        const viewProps = {
            ...this.props,
            slides: config.carouselItems,
            autoPlay: config.autoPlay ? config.autoPlay : false,
            autoPlayInterval: +(config.autoPlayInterval ? config.autoPlayInterval : 3)
        };
        return this.props.renderView(viewProps);
    }
}

export default MlCarousel;
